const fulldata = {
  2020: {
    chart1: [8, 12, 3, 5, 8, 3],
    chart2: [5, 4, 2, 5, 10, 7],
    chart3: [4, 2, 1, 5, 4, 8],
    chart4: [4, 5, 6, 8, 4, 5],
    chart5: [300, 50, 100],
    chart6: [30, 150, 200],
    chart7: [400, 250, 150],
    chart8: [100, 150, 50],
  },
  2019: {
    chart1: [5, 10, 14, 15, 16, 2],
    chart2: [4, 5, 6, 8, 4, 5],
    chart3: [5, 4, 2, 5, 10, 7],
    chart4: [4, 2, 1, 5, 4, 8],
    chart5: [175, 200, 100],
    chart6: [30, 150, 200],
    chart7: [400, 250, 150],
    chart8: [100, 150, 50],
  },
  2018: {
    chart1: [10, 15, 20, 14, 18, 10],
    chart2: [4, 2, 1, 5, 4, 8],
    chart3: [7, 4, 5, 8, 7, 4],
    chart4: [12, 19, 3, 5, 2, 3],
    chart5: [300, 50, 100],
    chart6: [30, 150, 200],
    chart7: [400, 250, 150],
    chart8: [100, 150, 50],
  },
  2017: {
    chart1: [8, 7, 5, 14, 10, 5],
    chart2: [10, 11, 12, 5, 10, 7],
    chart3: [4, 2, 1, 5, 4, 8],
    chart4: [12, 19, 3, 5, 2, 3],
    chart5: [200, 150, 100],
    chart6: [300, 75, 100],
    chart7: [100, 200, 150],
    chart8: [200, 150, 250],
  },
};

export default fulldata;
